const MINUTES_IN_HOUR = 60;

/**
 * The bar height that matches a spend alert's rate.
 *
 * The alert is a budget over its own window — "N tokens in W hours" — while the
 * chart draws whatever bucket size the range picked, so the configured number
 * cannot be plotted as-is. At a 6-hour bucket and a 1-hour alert, a line at N
 * would sit six times too high and imply headroom that does not exist.
 *
 * Converting to the alert's rate and back out to one bucket gives a line that
 * means the same thing at every range: a bar reaching it spent that bucket at
 * the rate the alert fires on.
 *
 * This is a pace, not a verdict. The alert evaluates a rolling window, so a
 * single bar above the line has not necessarily fired one, and a run of bars
 * just under it can. Callers should label it as a rate rather than as the
 * threshold itself.
 */
export function tokensPerBucketAtAlertRate(
  threshold: number,
  alertWindowHours: number,
  bucketMinutes: number,
): number | null {
  if (threshold <= 0 || alertWindowHours <= 0 || bucketMinutes <= 0) return null;
  return (threshold * (bucketMinutes / MINUTES_IN_HOUR)) / alertWindowHours;
}
